/**
 * CSS custom property written on the modal header by ModalHeaderActions with
 * the measured width of the actions slot, and read by the modal theme to
 * reserve matching space at the end of the header.
 */
export const MODAL_HEADER_ACTIONS_WIDTH_VAR = '--modal-header-actions-width';

export const MODAL_HEADER_ACTIONS_ATTRIBUTE = 'data-modal-header-actions';
